import { EmployeeWorkSheetDetails } from "@/model/employee-work-details/employee-worksheet-details";
import { Component, OnInit } from "@angular/core";
import { AppService } from "@services/app.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-data-entry-table",
  templateUrl: "./data-entry-table.component.html",
  styleUrl: "./data-entry-table.component.scss",
})
export class DataEntryTableComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  wagsMonth: string = "";
  getAllWagsMonth: string[] = [];
  worksheetEntryDetails: EmployeeWorkSheetDetails[] = [];
  isCountReadyOnly: boolean = false;
  TotalCompletedCount: string = "";
  TotalIndexCount: string = "";
  anyAddedImageCount: string = "";
  noExtractableDataCount: string = "";
  accountableIndexingCount: string = "";
  accountIndexingCost: string = "";
  assignCount: string = "";
  today: any;

  uniqueDates: any[] = [];
  selectedDate: string = '';

  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService
  ) { }

  ngOnInit() {
    this.getWagsMonthList();
  }

  /* Get wags month List */
  getWagsMonthList() {
    this.spinner.show();
    this.appService
      .getListOfWagsMonth()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          // Filter out empty strings
          this.getAllWagsMonth = data.filter((item) => item != "");

          this.getAllWagsMonth.sort((a, b) => {
            const dateA = new Date("01-" + a);
            const dateB = new Date("01-" + b);
            return dateB.getTime() - dateA.getTime();
          });

          // Set the first (latest) month
          this.wagsMonth = this.getAllWagsMonth[0];
          this.wagsMonthBasedDetailsGet(this.wagsMonth);
        },
        (error: any) => {
          // Handle error (optional)
          this.spinner.hide();
        }
      );
  }

  /* get wags month based worksheet details  */
  wagsMonthBasedDetailsGet(month: string) {
    this.spinner.show();
    this.appService
      .wagsMonthBasedDetailsGet(month)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.worksheetEntryDetails = data.sort(
            (a, b) => b.employeeDailyWorkLogId - a.employeeDailyWorkLogId
          );

          console.log(this.worksheetEntryDetails);


          this.updateTotals(this.worksheetEntryDetails);


          this.getUniqueDates();
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }


  updateTotals(list: any[]) {
  const totals = list.reduce(
    (acc, item) => {
      acc.completed += item.noOfImagesCompleted || 0;
      acc.indexed += item.noOfLinesTyped || 0;
      acc.noExtractable += item.noExtractableData || 0;
      acc.anyAddedImage += item.anyAddedImageCount || 0;
      acc.accountableIndex += item.accountableIndexing || 0;
      acc.accountIndexingCost += item.accountIndexingCost || 0;
      acc.assignCount += item.assignCount || 0;
      return acc;
    },
    {
      completed: 0,
      indexed: 0,
      noExtractable: 0,
      anyAddedImage: 0,
      accountableIndex: 0,
      accountIndexingCost: 0,
      assignCount: 0,
    }
  );

  this.TotalCompletedCount = totals.completed.toString();
  this.TotalIndexCount = totals.indexed.toString();
  this.assignCount = totals.assignCount.toString();
  this.noExtractableDataCount = totals.noExtractable.toString();
  this.anyAddedImageCount = totals.anyAddedImage.toString();
  this.accountableIndexingCount = totals.accountableIndex.toString();
  this.accountIndexingCost = totals.accountIndexingCost.toString();
}



  getUniqueDates() {
    const dateSet = new Set();

    this.worksheetEntryDetails.forEach(item => {
      const d = new Date(item.entryDate).toISOString().split('T')[0];
      dateSet.add(d);
    });

    this.uniqueDates = Array.from(dateSet);
  }


  onDateChange() {
  this.updateTotals(this.filteredEntries);
}

  get filteredEntries() {
    if (!this.selectedDate) {
      return this.worksheetEntryDetails;
    }

    return this.worksheetEntryDetails.filter(item => {
      const d = new Date(item.entryDate).toISOString().split('T')[0];
      return d === this.selectedDate;
    });
  }

  // Check if the current entry is the one with the highest employeeDailyWorkLogId
  checkLastEntryData(entry: any) {
    return (
      entry?.employeeDailyWorkLogId ===
      this.worksheetEntryDetails[0]?.employeeDailyWorkLogId
    );
  }
  //Remove entry details function
  removeEntryDetails(employeeDailyWorkLogId: number) {
    this.spinner.show();
    this.appService
      .EmployeeWorksheetDeleteById(employeeDailyWorkLogId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.toaster.success(`Details removed successfully.`);
          this.wagsMonthBasedDetailsGet(this.wagsMonth);
        },
        (error: any) => {
          this.toaster.error(
            error.error.message || "Something went wrong,please try again....."
          );
          this.spinner.hide();
        }
      );
  }
}
